import { all } from 'redux-saga/effects';
import login from './components/login/login.saga';
import app from './components/app/app.saga';
import courses from './components/courses/courses.saga';
import classes from './components/classes/classes.saga';
import tccs from './components/tccs/tccs.saga';
import onlineTests from './components/online-tests/online-tests.saga';
import questionsDatabase from './components/questions-database/questions-database.saga';
import addQuestion from './components/add-question/add-question.saga';
import manageQuestion from './components/manage-question/manage-question.saga';
import tests from './components/tests/tests.saga';
import testsConducted from './components/tests-conducted/tests-conducted.saga';
import users from './components/users/user.saga';
import trainers from './components/trainers/trainers.saga';
import global from './components/global/global.saga';
import centers from './components/centers/centers.saga';
import admin from './components/admin/admin.saga';
import admins from './components/admins/admins.saga';
import addTemplateTest from './components/add-template-test/add-template-test.saga';
import manageTemplateTest from './components/manage-template-test/manage-template-test.saga';
import duplicateTemplateTest from './components/duplicate-template-test/duplicate-template-test.saga';
import duplicateQuestion from './components/duplicate-question/duplicate-question.saga';

export default function* rootSaga() {
    yield all([
        login(),
        app(),
        courses(),
        classes(),
        tccs(),
        users(),
        trainers(),
        global(),
        centers(),
        admin(),
        admins(),
        onlineTests(),
        questionsDatabase(),
        tests(),
        testsConducted(),
        addQuestion(),
        manageQuestion(),
        addTemplateTest(),
        manageTemplateTest(),
        duplicateTemplateTest(),
        duplicateQuestion(),
    ]);
}



// WEBPACK FOOTER //
// ./src/rootsaga.js